module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop-placeholder-july2024-2917b35eb95df8e8ae87fedef890493c.webp";